import clsx from "clsx";
import type { ComponentProps } from "react";

import { ButtonWithIcon } from "@shared/ui/button-with-icon";
import { Icon } from "@shared/ui/icon";
import { Body } from "@shared/ui/typography";
import { formatNumberWithSpaces } from "@shared/utils/string";

import type { ExcursionType } from "@/_pages/excursion/model";

import s from "./excursion-content.module.scss";

export type CompProps = ComponentProps<"div"> & {
  data: ExcursionType;
  isTablet?: boolean;
  onButtonClick?: () => void;
};

export const ExcursionContent = (props: CompProps) => {
  const { data, isTablet, onButtonClick } = props;
  const details = data?.details;

  return (
    <div
      className={clsx(s.root, { [s.top]: isTablet })}
      data-inner-element="sections"
    >
      <div className={s.benefits}>
        {details?.duration != null && details.duration !== "" && (
          <div className={s.item}>
            <Icon name="clock" className={s.clockIcon} />
            <div>
              <Body
                size="uppercase-small"
                weight="semiBold"
                className={s.subtitle}
              >
                Продолжительность
              </Body>
              <Body size="uppercase-small" weight="semiBold">
                {details.duration}
              </Body>
            </div>
          </div>
        )}
        {details?.start != null && details.start !== "" && (
          <div className={s.item}>
            <Icon name="location" className={s.locationIcon} />
            <div>
              <Body
                size="uppercase-small"
                weight="semiBold"
                className={s.subtitle}
              >
                Старт экскурсии
              </Body>
              <Body size="uppercase-small" weight="semiBold">
                {details.start}
              </Body>
            </div>
          </div>
        )}
        {details?.groupPeople != null && details.groupPeople !== "" && (
          <div className={s.item}>
            <Icon name="trail" className={s.trailIcon} />
            <div>
              <Body
                size="uppercase-small"
                weight="semiBold"
                className={s.subtitle}
              >
                Минимальная группа
              </Body>
              <Body size="uppercase-small" weight="semiBold">
                {details.groupPeople}
              </Body>
            </div>
          </div>
        )}
        {details?.price != null && (
          <div className={s.item}>
            <Icon name="tiket" className={s.tiketIcon} />
            <div>
              <Body
                size="uppercase-small"
                weight="semiBold"
                className={s.subtitle}
              >
                цена
              </Body>
              <Body size="uppercase-small" weight="semiBold">
                {formatNumberWithSpaces(details.price)}/человек
              </Body>
            </div>
          </div>
        )}
      </div>
      <ButtonWithIcon
        variant="secondary-dark"
        onClick={onButtonClick}
        className={s.mainBtn}
        iconName="line-tree"
        iconFillColor="gold"
      >
        Оставить заявку на гида
      </ButtonWithIcon>
    </div>
  );
};

ExcursionContent.displayName = "ExcursionContent";
